<form [formGroup]="formTable" class="row" (ngSubmit)="addData()">
  <div class="col-6">
    <!-- <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>Fecha</mat-label>
      <input
        matInput
        placeholder="Fecha en que se envio la comunicación"
        formControlName="fecha"
        [matDatepicker]="picker3"
      />
      <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
      <mat-datepicker #picker3></mat-datepicker>
    </mat-form-field> -->
    <mat-form-field class="allSize" appearance="outline">
      <mat-label>Fecha/Hora</mat-label>
      <input matInput formControlName="fecha" type="datetime-local" />
    </mat-form-field>
  </div>
  <div class="col-6">
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>Monto</mat-label>
      <input
        type="number"
        matInput
        placeholder="Monto de la transacción"
        formControlName="monto"
      />
    </mat-form-field>
  </div>
  <div class="col-6">
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>Canal</mat-label>
      <mat-select formControlName="canal">
        <mat-option *ngFor="let canal of canalList" [value]="canal">
          {{ canal }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-6">
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>Banco</mat-label>
      <mat-select formControlName="banco">
        <mat-option *ngFor="let banco of bancosList" [value]="banco.nombre">
          {{ banco.nombre }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-12 padding">
    <div>
      <button
        *ngIf="!status"
        class="button"
        type="submit"
        [disabled]="formTable.invalid || submit"
      >
        Agregar
      </button>
    </div>
  </div>
</form>

<div class="task_content_table">
  <table mat-table #dataTable [dataSource]="dataSource" class="task_table">
    <ng-container matColumnDef="fecha">
      <th class="header-options" mat-header-cell *matHeaderCellDef>Fecha</th>
      <td mat-cell *matCellDef="let element">
        {{ element.fecha | date : "d/M/yy, h:mm a" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="monto">
      <th class="header-options" mat-header-cell *matHeaderCellDef>Monto</th>
      <td mat-cell *matCellDef="let element">
        {{ element.monto | number : "1.2-2" : "es" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="canal">
      <th class="header-options" mat-header-cell *matHeaderCellDef>Canal</th>
      <td mat-cell *matCellDef="let element">{{ element.canal }}</td>
    </ng-container>

    <ng-container matColumnDef="banco">
      <th class="header-options" mat-header-cell *matHeaderCellDef>Banco</th>
      <td mat-cell *matCellDef="let element">{{ element.banco }}</td>
    </ng-container>

    <ng-container matColumnDef="opciones">
      <th class="header-options" mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div class="options">
          <button class="delete" (click)="removeData(i)">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<mat-paginator
  [pageSizeOptions]="[5, 10, 25, 50, 100]"
  [pageSize]="5"
  [showFirstLastButtons]
></mat-paginator>
